import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=3eb40e68&scoped=true&"
import script from "./customized.vue?vue&type=script&lang=js&"
export * from "./customized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb40e68",
  null
  
)

export default component.exports